import React, { SVGProps } from "react";

export default function SupListLarge(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5ZM5 4.5C5 4.77614 4.77614 5 4.5 5C4.22386 5 4 4.77614 4 4.5C4 4.22386 4.22386 4 4.5 4C4.77614 4 5 4.22386 5 4.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 4.5C8 3.67157 8.67157 3 9.5 3H17V4C17 5.10457 16.1046 6 15 6H9.5C8.67157 6 8 5.32843 8 4.5ZM9.5 4H16C16 4.55228 15.5523 5 15 5H9.5C9.22386 5 9 4.77614 9 4.5C9 4.22386 9.22386 4 9.5 4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 10C8 9.17157 8.67157 8.5 9.5 8.5H17V9.5C17 10.6046 16.1046 11.5 15 11.5H9.5C8.67157 11.5 8 10.8284 8 10ZM9.5 9.5H16C16 10.0523 15.5523 10.5 15 10.5H9.5C9.22386 10.5 9 10.2761 9 10C9 9.72386 9.22386 9.5 9.5 9.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 14C8.67157 14 8 14.6716 8 15.5C8 16.3284 8.67157 17 9.5 17H15C16.1046 17 17 16.1046 17 15V14H9.5ZM16 15H9.5C9.22386 15 9 15.2239 9 15.5C9 15.7761 9.22386 16 9.5 16H15C15.5523 16 16 15.5523 16 15Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 11.5C5.32843 11.5 6 10.8284 6 10C6 9.17157 5.32843 8.5 4.5 8.5C3.67157 8.5 3 9.17157 3 10C3 10.8284 3.67157 11.5 4.5 11.5ZM4.5 10.5C4.77614 10.5 5 10.2761 5 10C5 9.72386 4.77614 9.5 4.5 9.5C4.22386 9.5 4 9.72386 4 10C4 10.2761 4.22386 10.5 4.5 10.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 15.5C6 16.3284 5.32843 17 4.5 17C3.67157 17 3 16.3284 3 15.5C3 14.6716 3.67157 14 4.5 14C5.32843 14 6 14.6716 6 15.5ZM5 15.5C5 15.7761 4.77614 16 4.5 16C4.22386 16 4 15.7761 4 15.5C4 15.2239 4.22386 15 4.5 15C4.77614 15 5 15.2239 5 15.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
